export const FirebaseConfig = {
  apiKey: "AIzaSyCbgLSdUGV45JHO9dTDz1JwbJDTGHel_V4",
  authDomain: "bigmanager-2580c.firebaseapp.com",
  projectId: "bigmanager-2580c",
  storageBucket: "bigmanager-2580c.appspot.com",
  messagingSenderId: "512577295261",
  appId: "1:512577295261:web:7c50c95af4a777bb451574",
  measurementId: "G-8E8DPQBKG7",
};
